<div *commonUiOptionalWizardStep id="organschaftsverhaeltnisseAngaben">

  <div class="mb-5x" >
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANTRAEGER.TITEL' | translate }}</h2>
    <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-2x">
      <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANTRAEGER.HINWEIS' | translate"
                      type="info">
      </common-ui-card>
    </div>
    <div class="mb-5x pt-1">
      <common-ui-organtraeger [(data)]="data.aufstellung" [readonly]="readonly">
      </common-ui-organtraeger>
    </div>
  </div>

  <h2 class="mb-3x">
    {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.TITEL' | translate }}</h2>

  <div class="form-row">
    <button (click)="addOrgantraeger()"
            *ngIf="!readonly && (isKapGAus ? data?.organtraegerKapGAus?.length : data?.organtraeger?.length) < maxAllowed"
            class="btn btn-light ml-2"
            id="addOrgantraeger"
            title="{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ADD_ORGANTRAEGER' | translate }}">
      <em class="icon icon-svg icon-fi-hinzufuegen"></em>
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ADD_ORGANTRAEGER' | translate }}
    </button>
  </div>

  <div class="mb-5x">
    <ul class="list-group d-flex" id="organtraegerList">

      <ng-container *ngIf="!isKapGAus">
        <ng-container *ngFor="let organtraeger of data.organtraeger; let i = index">
          <li
            (click)="toggleSelect(i)"
            (keyup.enter)="toggleSelect(i)"
            (keyup.space)="toggleSelect(i)"
            [ngClass]="{'common-ui-background-color-selected': selectedIndex === i}"
            class="list-group-item common-ui-list-group-item"
            [tabIndex]="0"
            id="organtraeger{{i}}">
            <div
              [ngClass]="{'active': selectedIndex === i }"
              class="d-flex justify-content-between common-ui-list-group-item-headings list-item-title">
              <div
                [innerText]="getDescription(organtraeger)"
                class="h5 ml-2x mb-0 col-8 pl-0 text-truncate"
                id="organtraegerDescription{{i}}"></div>
              <div class="d-flex flex-column ml-0 col-4 pl-0">
                <div id="labelKStUndGewStOrgangesellschaft">
                  <label *ngIf="organtraeger?.isKStUndGewStOrgangesellschaft"
                         class="h5 mb-0 font-organtraegerArt">- körperschaftsteuerlich und
                    gewerbesteuerlich</label>
                </div>
                <div id="labelUmStOrgantraegerIdentischKStUndGewStOrgantraeger">
                  <label *ngIf="organtraeger?.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger"
                         class="h5 mb-0 font-organtraegerArt">- ertragssteuerlich und
                    umsatzsteuerlich</label>
                </div>
                <div id="labelUmsatzsteuerOrgangesellschaft">
                  <label *ngIf="organtraeger?.isUmsatzsteuerOrgangesellschaft"
                         class="h5 mb-0 font-organtraegerArt">- umsatzsteuerlich</label>
                </div>
              </div>
            </div>
            <div class="common-ui-remove-element">
              <button (click)="removeOrgantraeger(i)" *ngIf="!readonly && data?.organtraeger?.length > 0"
                      class="btn btn-light btn-img"
                      id="removeOrgantraeger{{i}}"
                      title="{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.REMOVE_ORGANTRAEGER' | translate }}">
                <em class="icon icon-svg icon-fi-loeschen"></em>
              </button>
            </div>
          </li>
          <div
            [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
            class="containing-form">
            <common-ui-organschaftsverhaeltnisse-form
              [index]="i"
              [organtraegerDetail]="organtraeger"
              [readonly]="readonly" class="w-100">
            </common-ui-organschaftsverhaeltnisse-form>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="isKapGAus">
        <ng-container *ngFor="let organtraeger of data.organtraegerKapGAus; let i = index">
          <li
            (click)="toggleSelect(i)"
            (keyup.enter)="toggleSelect(i)"
            (keyup.space)="toggleSelect(i)"
            [ngClass]="{'common-ui-background-color-selected': selectedIndex === i}"
            class="list-group-item common-ui-list-group-item"
            [tabIndex]="0"
            id="organtraeger{{i}}">
            <div
              [ngClass]="{'active': selectedIndex === i }"
              class="d-flex justify-content-between common-ui-list-group-item-headings list-item-title">
              <div
                [innerText]="getDescription(organtraeger)"
                class="h5 ml-2x mb-0 col-8 pl-0 text-truncate"
                id="organtraegerDescription{{i}}"></div>
              <div class="d-flex flex-column ml-0 col-4 pl-0">
                <div>
                  <label *ngIf="organtraeger?.isKStUndGewStOrgangesellschaft"
                         class="h5 mb-0 font-organtraegerArt">- körperschaftsteuerlich und
                    gewerbesteuerlich</label>
                </div>
                <div>
                  <label *ngIf="organtraeger?.isUStOrgantraegerIdentisch"
                         class="h5 mb-0 font-organtraegerArt">- ertragssteuerlich und
                    umsatzsteuerlich</label>
                </div>
                <div>
                  <label *ngIf="organtraeger?.isUmsatzsteuerOrgangesellschaft"
                         class="h5 mb-0 font-organtraegerArt">- umsatzsteuerlich</label>
                </div>
              </div>
            </div>
            <div class="common-ui-remove-element">
              <button (click)="removeOrgantraeger(i)" *ngIf="!readonly && data?.organtraegerKapGAus?.length > 0"
                      class="btn btn-light btn-img"
                      id="removeOrgantraeger{{i}}"
                      title="{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.REMOVE_ORGANTRAEGER' | translate }}">
                <em class="icon icon-svg icon-fi-loeschen"></em>
              </button>
            </div>
          </li>
          <div
            [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
            class="containing-form">
            <kapgaus-organschaftsverhaeltnisse-form
              [index]="i"
              [organtraegerDetail]="organtraeger"
              [readonly]="readonly" class="w-100">
            </kapgaus-organschaftsverhaeltnisse-form>
          </div>
        </ng-container>
      </ng-container>

    </ul>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.TITEL' | translate }}</h2>
    <common-ui-konzern
      [(data)]="data.konzern"
      [readonly]="readonly">
    </common-ui-konzern>
  </div>

</div>
